import { DEFAULT_LOCALE } from 'localization/constants/configEnums';

export const localizeUrl = (html: string, locale?: string): string => {
  if (!html) {
    return html;
  }
  const re = new RegExp('href=("|\')?((http(s)?://)?(www.)?goat.com(/)?|/)', 'g');
  if (!locale || locale === DEFAULT_LOCALE) {
    return html.replace(re, 'href=$1/');
  }
  return html.replace(re, `href=$1/${locale}/`);
};
